import styled from 'styled-components'
import { GatsbyImage } from 'gatsby-plugin-image'
import { display } from 'styled-system'
import theme from 'styles/theme'
import { appearingAnimation } from 'styles/animation'
import { Title42, Eyebrow } from 'components/Typography'

const animationProps = `
  animation-direction: normal;
  animation-duration: 1.4s;
  animation-iteration-count: 1;
  animation-fill-mode: forwards;
  animation-timing-function: cubic-bezier(.54,0,.15,1);
`

const copyProps = `
  z-index: 1;
  position: relative;
  color: white;
  text-align: left;
  max-width: 700px;
  width: 80%;
  margin: 10px 0 0;
  line-height: 1.2;

  ${theme.mediaQueries.large} {
    margin: 20px 0 0;
    max-width: calc(100% - 140px);
  }

  html[dir="rtl"] & {
    text-align: right;
    left: calc(20% - 30px);

    ${theme.mediaQueries.large} {
      left: calc(20% - 60px);
    }
  }
`

export const CarouselImage = styled.div`
  height: 150vw;
  max-height: 600px;
  width: 100%;
  transition: transform 0.8s ease-in-out;
  transition-timing-function: cubic-bezier(0.54, 0, 0.15, 1);
  transform: translate3d(0, 0, 0);

  &::before {
    content: '';
    display: block;
    height: 0;
    padding-top: 150%;
    width: 100%;

    ${theme.mediaQueries.medium} {
      padding-top: 56%;
    }
  }

  ${theme.mediaQueries.small} {
    max-height: 1200px;
  }

  ${theme.mediaQueries.medium} {
    max-height: none;
    height: 56vw;
  }

  .gatsby-image-wrapper {
    height: 101%;
    left: 0;
    position: absolute !important;
    top: 0;
    width: 100%;
  }

  ${(props) =>
    props.isNext &&
    `transform: translate3d(-30px, 0, 0);

    ${theme.mediaQueries.large} {
      transform: translate3d(-60px, 0, 0);
    }

  `}

  ${(props) =>
    props.currentSlide === 0 && props.rtl && `transform: translate3d(0, 0, 0);`}

  ${(props) =>
    props.isPrev &&
    `transform: translate3d(0, 0, 0);

      ${theme.mediaQueries.large} {
        transform: translate3d(60px, 0, 0);
      }
    }
  `}

  ${(props) =>
    props.currentSlide > 0 && props.rtl && `transform: translate3d(30px, 0, 0)`}

`

export const CarouselImg = styled(GatsbyImage)`
  ${display}
`

export const CarouselVideo = styled.div`
  align-items: center;
  display: flex;
  height: 101%;
  justify-content: center;
  left: 0px;
  overflow: hidden;
  position: absolute;
  top: 0;
  width: 120%;

  > div {
    height: auto;
    min-height: 100%;
  }
`

export const CarouselContent = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  position: absolute;
  width: 100%;
  margin: 0;
  height: auto;
  bottom: 0;
  left: 0;
  padding: 0 ${theme.space[3]};
  z-index: 3;
`

export const CarouselContentWrapper = styled.div`
  max-width: ${theme.containterMaxWidth};
  display: flex;
  flex-direction: column;
  position: relative;
  width: 100%;
  margin: 0 auto;
  padding-bottom: 30px;

  ${theme.mediaQueries.large} {
    padding-bottom: 50px;
  }
`

export const CarouselCopy = styled(Title42)`
  ${copyProps}
  opacity: 0;
  animation: ${appearingAnimation(null, '100px')} .3s ease-out;
  ${animationProps}
  animation-delay: ${(props) => props.delay};
`

export const CarouselEyebrow = styled(Eyebrow)`
  ${copyProps}
  opacity: 0;
  animation: ${appearingAnimation(null, '100px')} .3s ease-out;
  ${animationProps}
  animation-delay: ${(props) => props.delay};
`

export const CarouselMetaDivider = styled.span`
  display: inline-block;
  margin: 0 ${theme.space[1]};
`

export const CarouselOverlayContainer = styled.div`
  ${(props) =>
    props.showOverlay &&
    `
    ::before, ::after {
      content: '';
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
    }

    ::before {
      background: rgba(69, 69, 69, 0.3);
      z-index: 1;
    }

    ::after {
      background-image: linear-gradient(transparent, black);
      opacity: 0.45;
      z-index: 2;
    }
  `}
`
